export default {
  price_estimation: {
    title: 'Property Valuation',
    summary_title: 'Summary Indicators',
    avg_label: 'Average Price',
    median_label: 'Median Price',
    models_title: 'Estimator24 Models',
    not_ready: 'Valuation not yet performed',
    ai_prediction: 'AI Valuation',
    market_range: 'Market',
    price_label: 'Listing Price',
    within_range: 'Within market range',
    above_range: 'Overpriced by +{percent}%',
    below_range: 'Below market by −{percent}%'
  }
}
